import { Injectable } from '@kaokei/use-vue-service';
import axios from '@/utils/request';
import { domains } from '@/utils';
import { UserExam, UserExamList } from '@/types';
export interface IState {
  status: number;
  activityTag: string;
}

@Injectable()
export class AiicUserExamService {
  // 0:未开始 1:进行中 2:已结束
  public status = 1;
  // 白名单赛事标识
  public activityTag = '';

  public userExamList: UserExamList = [];

  public userExam!: UserExam;

  public interTimer!: any;

  public loading = false;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  public setAttrs(data: Partial<IState>) {
    const enumKeys: (keyof IState)[] = ['status', 'activityTag'];
    enumKeys.forEach(key => {
      if (data[key] !== undefined) {
        (this[key] as any) = data[key];
      }
    });
  }

  public search(autoRefresh?: boolean) {
    if (!autoRefresh) {
      window.scrollTo(0, 0);
    }
    clearInterval(this.interTimer);
    this.loading = true;
    return this.getIccExamList({
      status: this.status,
      activityTag: this.activityTag,
    })
      .then(res => {
        this.userExamList = res || [];
        // TODO: del mock data config
        // this.userExamList[0].startTime = Date.now() + 1000 * 60 * 0.2;
        clearInterval(this.interTimer);
        /**
         * status 状态
         * NOTHING(0, "没有任何按钮信息")
         * EXAMINATION(1, "开始考试")
         * DEFENCE(2, "开始答辩")
         * WAITING(3, "即将考试")
         * BEFORE_CHECK(4, "考试准备")
         * 开启考前检录的status状态
         * 未开启考前检录的status状态
         */
        this.interTimer = setInterval(() => {
          const waitStartList = this.userExamList.filter(item =>
            [3, 4].includes(item.status)
          );
          if (!waitStartList.length) {
            clearInterval(this.interTimer);
            return;
          }
          waitStartList.forEach((item: any) => {
            const { userSupportCheck } = item;
            const needCheckDevice = Boolean(
              userSupportCheck?.deviceCheckConfig
            );
            if (
              needCheckDevice &&
              item.startTime < Date.now() + 1000 * 60 * 60
            ) {
              item.status = 4;
            } else {
              if (item.startTime < Date.now()) {
                item.status = 1;
              }
            }
          });
        }, 2000);
      })
      .catch(() => {
        clearInterval(this.interTimer);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  public clearTimer() {
    clearInterval(this.interTimer);
  }

  public resetSearch() {
    this.search();
  }

  /**
   * 获取用户赛事列表
   *
   * @return {*}
   * @memberof DaoService
   */
  public getIccExamList(params: any) {
    return axios.get<UserExamList>(
      `${domains.apiDomain}/contest-exam/userContest/v1/whiteList/userContestList`,
      {
        params,
      }
    );
  }
}
